import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-32 text-center" data-id="element-498" data-mp="w3ztfmzgnvxh">
      <h1 className="text-4xl font-semibold tracking-display" data-id="element-499" data-mp="105us0jq0bv7k">Deze pagina bestaat niet</h1>
      <p className="mt-3 text-muted" data-id="element-500" data-mp="1087ixmdqtfwr">Misschien is het product verplaatst. Bekijk onze bestsellers.</p>
      <Link to="/collectie/bestsellers" className="mt-8 inline-flex h-12 items-center rounded-full bg-ink px-6 text-sm font-medium text-canvas hover:bg-clay" data-id="element-501" data-mp="152lafdpab2w5">
        Naar bestsellers
      </Link>
    </div>;
}